import { Currencies, Currency } from "ts-money";

import { Models } from "api/types";

class CurrencyService {
  private currency: Currency = Currencies.USD;

  public setCurrency(stripeRegion: Models<"StripeRegion"> | undefined): void {
    this.currency = {
      US: Currencies.USD,
      CA: Currencies.CAD,
    }[stripeRegion ?? "US"];
  }

  public getCurrency(): Currency {
    return this.currency;
  }
}

export const currencyService = new CurrencyService();
